import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  Avatar,
} from "@mui/material";
import { createAvatar } from "@dicebear/core";
import * as collection from "@dicebear/collection";
import startCase from "lodash/startCase";

const formatCamelCase = (text) => startCase(text);

const transformToDicebearConfig = (config) =>
  Object.fromEntries(Object.entries(config).map(([k, v]) => [k, [v]]));

const AvatarPropertyField = ({
  propertyKey,
  fieldSchema,
  avatarStyle,
  customOptions,
  onChange,
  seed,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const options =
    fieldSchema.enum ||
    (fieldSchema.type === "array" && fieldSchema.items?.type === "string"
      ? fieldSchema.default || []
      : []);

  if (!options || options.length <= 1) return null;

  const selected = customOptions[propertyKey] || options[0];

  return (
    <FormControl variant="outlined" sx={{ width: 300 }}>
      <InputLabel id={`${propertyKey}-label`} htmlFor={propertyKey}>
        {formatCamelCase(propertyKey)}
      </InputLabel>
      <Select
        label={formatCamelCase(propertyKey)}
        labelId={`${propertyKey}-label`}
        value={selected}
        onChange={(e) => onChange(propertyKey, e.target.value)}
        onOpen={() => setIsDropdownOpen(true)}
        onClose={() => setIsDropdownOpen(false)}
        slotProps={{
          input: {
            id: propertyKey
          }
        }}
        renderValue={(selected) =>
          propertyKey.toLowerCase().includes("color") ? (
            <Box
              sx={{
                width: 24,
                height: 24,
                backgroundColor: `#${selected.slice(0, 6)}`,
                borderRadius: 1,
                border: "1px solid #ccc",
              }}
            />
          ) : isDropdownOpen ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography>{formatCamelCase(selected)}</Typography>
            </Box>
          ) : (
            formatCamelCase(selected)
          )
        }
      >
        {options.map((option) => {
          // Preview uses all current props except this property swapped for option
          const previewProps = { ...customOptions, [propertyKey]: option };
          const previewSvg = createAvatar(collection[avatarStyle], {
            ...transformToDicebearConfig(previewProps),
            seed,
          }).toString();

          const preview = `data:image/svg+xml;utf8,${encodeURIComponent(
            previewSvg
          )}`;

          return (
            <MenuItem key={option} value={option}>
              {propertyKey.toLowerCase().includes("color") ? (
                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    backgroundColor: `#${option.slice(0, 6)}`,
                    border: "1px solid #ccc",
                  }}
                />
              ) : (
                formatCamelCase(option)
              )}
              {isDropdownOpen && (
                <Avatar
                  src={preview}
                  sx={{
                    width: 40,
                    height: 40,
                    ml: 2,
                    bgcolor: "grey.200",
                    borderRadius: 1,
                  }}
                  variant="rounded"
                />
              )}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default AvatarPropertyField;
